import Item from './Item';

const List = ({ title, description = '', badge = null, consents = [], onOpen }) => {
  if (!consents.length) return null;

  return (
    <div className="mb-5 overflow-hidden rounded-xl border border-gray-200 bg-white animate-slide-up">
      <div className="flex items-center justify-between gap-3 border-b border-gray-100 bg-secondary-50/70 px-4 py-3">
        <div className="min-w-0">
          <p className="text-[15px] font-bold text-secondary-900">{title}</p>
          {description && <p className="mt-0.5 text-xs text-amber-700">{description}</p>}
        </div>

        {badge}
      </div>

      <div className="divide-y divide-gray-100">
        {consents.map((consent) => (
          <Item key={consent.id} consent={consent} onClick={() => onOpen(consent)} />
        ))}
      </div>
    </div>
  );
};

export default List;
